import { useEffect, useState } from 'react'
import { subscribeToPrices } from '@/features/prices/prices-api'
import type { MaterialPrice } from '@/lib/types'

/** Live prices visible to the signed-in admin (own + shared), keyed by material id. */
export function usePrices(uid: string | undefined): {
  prices: Map<string, MaterialPrice>
  isLoading: boolean
  error: string | null
} {
  const [prices, setPrices] = useState<Map<string, MaterialPrice>>(new Map())
  const [isLoading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!uid) return
    return subscribeToPrices(
      uid,
      (items) => {
        setPrices(new Map(items.map((item) => [item.materialId, item])))
        setLoading(false)
      },
      (caught) => {
        setLoading(false)
        setError(
          caught.message.includes('permission')
            ? 'Firestore отклонил чтение коллекции prices. Опубликуйте правила с блоком prices.'
            : caught.message,
        )
      },
    )
  }, [uid])

  return { prices, isLoading, error }
}
